import '@oysterjs/core/apm';

import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { client } from './api/client';
import { applyTheme, readThemePreference, watchSystemTheme } from './lib/theme';
import { router } from './router';

// index.html has already set the class from the same preference; this re-applies
// it for completeness and starts following the OS, which the inline script
// cannot do because it only runs once.
applyTheme(readThemePreference());
watchSystemTheme();

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);

root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <RouterProvider router={router} useTransitions={false} />
    </ApolloProvider>
  </React.StrictMode>
);
